// 标签模板列表页面翻译
export default {
  // 页面标题
  title: "标签模板列表",

  // 按钮文本
  buttons: {
    addTemplate: "新增标签模板",
    search: "查询",
    reset: "重置",
  },

  // 弹窗标题
  dialog: {
    addTemplate: "新增标签模板",
  },

  // 搜索表单
  search: {
    placeholder: "请输入查询标签名",
    dateRange: {
      startPlaceholder: "开始日期",
      endPlaceholder: "结束日期",
      separator: "→",
    },
  },

  // 表格相关
  table: {
    totalData: "条数据",
    totalPrefix: "共计",
    pagination: {
      itemsPerPage: "条/页",
      total: "共",
      items: "项",
    },
  },

  // 操作相关
  actions: {
    edit: "编辑",
    delete: "删除",
    view: "查看",
    copy: "复制",
    download: "下载",
    upload: "上传",
  },

  // 状态显示
  status: {
    public: "是",
    private: "否",
    enabled: "启用",
    disabled: "禁用",
  },

  // 提示信息
  messages: {
    confirmClose: "确认关闭？",
    deleteConfirm: "确认删除该标签模板？",
    deleteSuccess: "删除成功",
    saveSuccess: "保存成功",
    copySuccess: "复制成功",
    noData: "暂无数据",
    loadError: "加载失败，请稍后重试",
  },

  // 表单验证
  validation: {
    nameRequired: "请输入标签名称",
    nameLength: "标签名称长度应在2-50个字符之间",
    descriptionRequired: "请输入标签描述",
    descriptionLength: "描述长度不能超过200个字符",
  },

  // 表格列标题
  columns: {
    name: "标签名",
    description: "描述",
    creator: "创建用户名",
    createTime: "创建时间",
    modifiedTime: "修改时间",
    propertyPublic: "属性是否公开",
    status: "状态",
    operations: "操作",
  },

  // 文件上传相关
  upload: {
    resultTitle: "标签上传结果",
    noUpload: "暂无上传",
    result: "上传结果",
    batchResultTitle: "标签批量上传结果",
  },

  // 批量修改对话框 (alterLabel.vue)
  batchModify: {
    title: "批量修改",
    instruction1:
      "点击下方下载按钮，下载当前标签冲突的所有地址到本地批量修改；",
    instruction2: "点击下方上传按钮，将已修改的文件上传并同步至平台。",
    downloadBtn: "下 载",
    uploadBtn: "上 传",
    downloadFileName: "标签批量下载",
    uploadSuccess: "上传成功",
    uploadError: "上传失败，请刷新页面重新上传，或检查网络",
    uploadErrorTitle: "提示",
    fileTypeError: "只能上传excel的文件",
  },

  // 新增标签页面 (newLabel.vue)
  newLabel: {
    // 表单标签
    form: {
      labelName: "标签名称",
      labelIcon: "标签图标",
      labelSort: "标签排序",
      labelPublicType: "标签公开类型",
      propertyPublic: "标签属性是否公开",
      labelType: "标签类型",
      addAttribute: "添加标签属性",
      canDelete: "标签是否可以删除",
    },

    // 表单占位符文本
    placeholders: {
      labelName: "请输入标签名称",
      labelSort: "请输入标签排序",
      publicType: "非公开",
      propertyPublic: "是",
      labelType: "请选择",
      canDelete: "是",
    },

    // 选项文本
    options: {
      public: "公开",
      private: "非公开",
      yes: "是",
      no: "否",
    },

    // 上传相关
    upload: {
      clickToUpload: "+ 点击上传标签图标",
      addMultiple: "+ 可添加多个",
    },

    // 提示文本（原CSS伪元素内容）
    hints: {
      iconSize: "标签图标尺寸100px*100px,图片大小不超过1M",
      sortRange: "标签显示权重0-9999,数字越小权重越大",
      publicTypeDesc: "公开：所有人可见；非公开：仅自己可见",
      attributeDesc: "给标签备注属性字段",
    },

    // 按钮文本
    buttons: {
      reset: "重置",
      submit: "提交",
    },

    // 验证消息
    validation: {
      nameRequired: "请输入标签名称",
      iconRequired: "请上传标签图标",
      sortRequired: "请输入标签排序",
      publicTypeRequired: "请选择标签公开类型",
      propertyPublicRequired: "请选择标签属性是否公开",
      labelTypeRequired: "请选择标签类型",
      canDeleteRequired: "请选择标签是否可以删除",
    },

    // 成功消息
    messages: {
      addSuccess: "新增标签成功",
      uploadError: "上传失败，请刷新页面重新上传，或检查网络",
      uploadErrorTitle: "提示",
    },

    // 标签属性子组件 (moreAttributeChild.vue)
    attributeChild: {
      // 表单标签
      form: {
        attributeName: "属性名称",
        required: "是否必填",
        attributeType: "属性选填类型",
        configureFields: "配置属性字段",
      },

      // 占位符
      placeholders: {
        attributeName: "请输入",
        attributeType: "请选择",
        fieldPlaceholder: "属性字段",
        fieldTextPlaceholder: "请输入属性字段文案",
      },

      // 选项文本
      options: {
        yes: "是",
        no: "否",
        textInput: "文本输入(手动输入)",
        enumField: "属性字段选填(选择字段)",
      },
    },
  },

  // 标签结果页面 (labelResult.vue)
  labelResult: {
    // 标签上传统计
    uploadSummary: {
      prefix: "共上传成功了",
      middle1: "个[",
      middle2: "]标签的地址,其中有",
      middle3: "个地址已有[",
      middle4: "]标签,其中字段有冲突的请查看下方表格内容,有",
      suffix: "个上传失败的地址。",
    },

    // 标签页
    tabs: {
      conflictLabel: "冲突标签",
      failedLabel: "上传失败标签",
    },

    // 冲突标签部分
    conflict: {
      batchModifyBtn: "批量修改",
      copySuccess: "复制成功",
      originalAttributes: "原标签属性字段",
      newAttributes: "新标签属性字段",
      placeholderText: "这里是新的备注文案",
      mergeBtn: "合并",
      coverBtn: "覆盖",
      batchMergeBtn: "一键合并",
      batchCoverBtn: "一键覆盖",
      conflictTotal: "冲突标签共",
      conflictTotalSuffix: "个",
      prevBtn: "< 上一条",
      nextBtn: "下一条 >",
    },

    // 失败标签部分
    failed: {
      addressColumn: "地址",
      labelNameColumn: "标签名称",
      reasonColumn: "失败原因",
      failedTotal: "上传失败标签共",
      failedTotalSuffix: "页",
      prevPageBtn: "< 上一页",
      nextPageBtn: "下一页 >",
    },

    // 空数据状态
    empty: {
      text: "暂无数据",
    },

    // 操作结果消息
    operationMessages: {
      mergeSuccess: "标签合并成功",
      coverSuccess: "标签覆盖成功",
      batchMergeSuccess: "一键合并成功",
      batchCoverSuccess: "一键覆盖成功",
    },
  },
};
